// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s93A","rootMobile":"styles_rootMobile__2NM1z"};